// extracted by mini-css-extract-plugin
export default {"header":"Modal_header__aEZXE","footer":"Modal_footer__bKgS3"};